import React from "react";
import Image from "next/image";

interface LogoProps {
  width?: number;
  height?: number;
}

const Logo: React.FC<LogoProps> = ({ width = 400, height = 400 }) => {
    return (
        <Image
            className={`w-${width} h-${height}`}
            src="/logo.png"
            alt="Logo"
            width={500}
            height={500}
        />
    );
};

export default Logo;
